import { Col, Row } from "antd";
import "@/entities/journal";
import { routes, Link } from "@/shared/lib/react-router";
import { LinkIcon } from "@shared/assets/svg/icons";
import { fallbackString } from "@shared/utils";
import "./section-fourth-control-subject.scss";

interface Work {
  workName?: string;
  itemNoVersionId?: string;
}

interface SectionFourthControlSubjectProps {
  structuralElementName?: string;
  locationDescription?: string;
  works?: Work[];
  projectId?: string;
  objectId?: string;
  mainJournalId?: string;
  titleId?: string;
}

export const SectionFourthControlSubject = ({
  structuralElementName,
  locationDescription,
  works,
  projectId,
  objectId,
  mainJournalId,
  titleId,
}: SectionFourthControlSubjectProps) => {
  const worksText = works?.map((w) => w.workName).join("\n") || "";

  return (
    <div className="section-fourth-control-subject">
      <div className="section-fourth-control-subject__section">
        <div className="section-fourth-control-subject__title">
          Описание предмета контроля
        </div>

        <div className="section-fourth-control-subject__table">
          <Row className="section-fourth-control-subject__row">
            <Col span={8} className="section-fourth-control-subject__label">
              Наименование и обозначение структурного элемента объекта капитального строительства
            </Col>
            <Col span={16} className="section-fourth-control-subject__text">
              {fallbackString(structuralElementName)}
            </Col>
          </Row>

          <Row className="section-fourth-control-subject__row">
            <Col span={8} className="section-fourth-control-subject__label">
              Местоположение
            </Col>
            <Col span={16} className="section-fourth-control-subject__text">
              {fallbackString(locationDescription)}
            </Col>
          </Row>

          <Row className="section-fourth-control-subject__row">
            <Col span={8} className="section-fourth-control-subject__label">
              Выполненные работы
            </Col>
            <Col span={16} className="section-fourth-control-subject__text">
              {works && works.length > 0 ? (
                <div className="section-fourth-control-subject__works">
                  {works.map((work) => (
                    <div
                      key={work.itemNoVersionId || work.workName}
                      className="journal-info-work-row"
                    >
                      <Link
                        to={
                          routes.journals.section3(
                            projectId || "",
                            objectId || "",
                            mainJournalId || "",
                            titleId || "",
                          ) +
                          (work.itemNoVersionId
                            ? `?itemNoVersionId=${work.itemNoVersionId}`
                            : "")
                        }
                        rel="nofollow"
                        className="journal-info-work-link"
                        target="_blank"
                      >
                        {work.workName || "-"}
                      </Link>
                      <LinkIcon />
                    </div>
                  ))}
                </div>
              ) : (
                fallbackString(worksText)
              )}
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
